{
  "page": {
    "title": "数据生成器",
    "description": "通过常规 API 创建带头像和图钉的测试人才。仅限开发和 QA 环境。",
    "frameTitle": "人才",
    "viewModeConfig": "配置",
    "viewModeResult": "预览",
    "viewModeSplit": "并排",
    "hostNotAllowed": "数据生成器仅在 localhost、开发和 QA 环境中运行。",
    "sidebarLink": "数据生成器"
  },
  "config": {
    "presets": "预设",
    "preset": {
      "quick": "快速 10 个",
      "heavy-shortlist": "大型候选名单 500",
      "edge-cases": "边界情况"
    },
    "basics": "批次",
    "seed": "种子",
    "seedHelp": "相同的种子和设置会生成相同的人。",
    "newSeed": "新种子",
    "count": "人才数量",
    "resourceType": "资源类型",
    "membership": "可见性",
    "names": "姓名来源",
    "namesHelp": "每种语言的权重；0 表示不使用。",
    "locale": {
      "en": "英语",
      "pl": "波兰语",
      "de": "德语",
      "fr": "法语",
      "it": "意大利语",
      "es": "西班牙语",
      "ja": "日语",
      "pt_BR": "巴西葡萄牙语"
    },
    "details": "详细信息",
    "fill": {
      "email": "邮箱",
      "phone": "电话",
      "role": "职位"
    },
    "avatars": "头像",
    "avatarsHelp": "每种风格的权重；头像由种子生成。",
    "rerollFaces": "换一批头像",
    "avatarSource": {
      "lorelei": "Lorelei",
      "notionists": "Notionists",
      "avataaars": "Avataaars",
      "open-peeps": "Open Peeps",
      "micah": "Micah",
      "personas": "Personas",
      "photo": "照片",
      "none": "无头像"
    },
    "pins": "图钉",
    "pinCount": "每位人才的图钉：{{min}}–{{max}}",
    "portraitShare": "竖版：{{percent}}%",
    "pinSource": {
      "photos": "照片",
      "faces": "头像"
    },
    "edgeCases": "边界情况：{{percent}}%",
    "edgeCasesHelp": "超长或非拉丁字母的姓名、没有任何信息的人才、40 个图钉。",
    "shortlist": "候选名单",
    "createShortlist": "将本批次加入新的候选名单",
    "shortlistTitle": "标题",
    "shortlistWorkspace": "工作区",
    "shortlistTeam": "团队",
    "noWorkspace": "组织（无工作区）",
    "pickTeam": "选择团队",
    "run": "创建 {{count}} 位人才"
  },
  "preview": {
    "title": "预览：{{count}} 位中的前 {{shown}} 位",
    "loadFailed": "无法生成预览：{{message}}",
    "noDetails": "无信息",
    "pinCount_other": "{{count}} 个图钉"
  },
  "run": {
    "talents": "正在创建人才：{{done}} / {{total}}",
    "shortlist": "正在填充候选名单…",
    "stopping": "正在处理中的人才完成后停止…",
    "stop": "停止",
    "failures_other": "{{count}} 个失败",
    "failure": "#{{index}}：{{message}}",
    "status": {
      "done": "批次已创建",
      "stopped": "已停止",
      "auto-stopped": "连续 5 次错误后已停止",
      "restored": "上一批次"
    },
    "created_other": "已创建 {{count}} 位人才",
    "batchTag": "标签 {{tag}}",
    "showTalents": "查看人才",
    "openShortlist": "打开候选名单",
    "shortlistFailed": "候选名单失败：{{message}}",
    "archive": "归档本批次",
    "archived": "已归档",
    "failed": "运行失败：{{message}}"
  }
}
